module.exports = __webpack_public_path__ + "img/user_avatar.7140799e.png";